/* Minuzza CRO: sacola (gaveta e /cart).
   1) M-45: troca de numeração na linha do item. Ordem segura: PRIMEIRO /cart/add.js com a nova variante (mesma quantidade),
      DEPOIS a remoção da linha antiga, feita pelo próprio tema (evento theme:cart:update com quantidade 0, com o índice da linha
      refeito a partir de /cart.js); o tema então refaz a gaveta/lista, os totais e o contador. Se a adição falhar, nada muda.
   2) M-02: barra fixa com o total no celular, só na página /cart (o rótulo de parcelas segue a parcela mínima de R$ 100).
   Carregado por snippets/cro-sacola-js.liquid. Sem jQuery e sem dependência nova. */
(function () {
  'use strict';
  if (window.__croCart) return;
  window.__croCart = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var live = null;
  var escHandled = false;

  /* ------------------------------------------------------------------ utilidades */

  function announce(text) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'cro-sr';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    window.setTimeout(function () { live.textContent = text; }, 40);
  }

  function setMsg(item, text, kind) {
    var el = item && item.querySelector('[data-cro-size-msg]');
    if (!el) return;
    el.textContent = text || '';
    el.className = 'cro-size__msg' + (text ? ' is-on' : '') + (kind === 'error' ? ' is-error' : '');
    if (text) announce(text);
    /* na gaveta a lista rola: garante que o aviso apareça */
    if (kind === 'error' && el.scrollIntoView) el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function itemByKey(key) {
    return document.querySelector('[data-cart-item][data-item="' + String(key).replace(/"/g, '\\"') + '"]');
  }

  function getJSON(res) {
    return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; }, function () { return { ok: res.ok, status: res.status, data: {} }; });
  }

  function setBusy(item, on) {
    item.__croBusy = on;
    item.classList.toggle('cro-line--busy', on);
    item.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  /* ------------------------------------------------------------------ painel de numeração */

  function closePanels(except) {
    document.querySelectorAll('[data-cro-size-toggle][aria-expanded="true"]').forEach(function (toggle) {
      var item = toggle.closest('[data-cart-item]');
      if (item === except) return;
      toggle.setAttribute('aria-expanded', 'false');
      var panel = item.querySelector('.cro-size__panel');
      if (panel) panel.hidden = true;
    });
  }

  function togglePanel(toggle, byKeyboard) {
    var item = toggle.closest('[data-cart-item]');
    var panel = item && item.querySelector('.cro-size__panel');
    if (!panel || item.__croBusy) return;
    var open = toggle.getAttribute('aria-expanded') !== 'true';
    closePanels(open ? item : null);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    if (open) {
      setMsg(item, '');
      /* teclado: o painel fica depois dos outros controles da linha, então o foco vai direto para a numeração atual */
      var current = byKeyboard && panel.querySelector('[aria-pressed="true"]');
      if (current) current.focus();
      if (panel.scrollIntoView) panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  /* ------------------------------------------------------------------ troca de numeração */

  function addErrorText(result, size, qty) {
    if (result.status === 422) {
      return 'Não há estoque para ' + (qty > 1 ? qty + ' pares ' : 'esse par ') + 'no número ' + size + '. Escolha outro número ou diminua a quantidade. Sua sacola não mudou.';
    }
    return 'Não deu para trocar a numeração agora. Nada mudou na sua sacola. Tente de novo.';
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      if (!res.ok) throw new Error('cart.js ' + res.status);
      return res.json();
    });
  }

  function linesOf(cart, variantId) {
    return (cart.items || []).filter(function (it) { return Number(it.variant_id) === variantId; });
  }

  function swap(item, opt) {
    if (item.__croBusy) return;
    var newId = Number(opt.getAttribute('data-variant-id'));
    var size = opt.getAttribute('data-size');
    var oldKey = item.getAttribute('data-item');
    var qty = Math.max(1, Number(item.getAttribute('data-cro-qty')) || 1);
    var line = { id: newId, quantity: qty };
    var raw = item.getAttribute('data-cro-properties');
    if (raw) { try { line.properties = JSON.parse(raw); } catch (e) { /* sem propriedades */ } }

    setBusy(item, true);
    setMsg(item, 'Trocando para o ' + size + '…');

    /* foto da sacola ANTES de adicionar: a Shopify, quando falta estoque, responde 422 mas JÁ adiciona o que havia ("Apenas 1 item foi
       adicionado ao seu carrinho devido à disponibilidade"). Se isso acontecer, a sobra é desfeita para a sacola ficar como estava. */
    getCart()
      .then(function (cart) {
        var before = {};
        linesOf(cart, newId).forEach(function (it) { before[it.key] = it.quantity; });
        return fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [line] })
        })
          .then(getJSON, function () { return { ok: false, status: 0, data: {} }; })
          .then(function (result) {
            if (!result.ok) { undoAdd(item, newId, before, size, qty, result); return; }
            var added = (result.data.items && result.data.items[0]) || result.data;
            removeOld(item, oldKey, added, size, qty);
          });
      })
      .catch(function () {
        setBusy(item, false);
        setMsg(item, addErrorText({ status: 0 }, size, qty), 'error');
      });
  }

  /* a adição falhou: confere a sacola e devolve qualquer quantidade que a Shopify tenha adicionado pela metade */
  function undoAdd(item, newId, before, size, qty, result) {
    getCart()
      .then(function (cart) {
        var extra = linesOf(cart, newId).filter(function (it) { return it.quantity > (before[it.key] || 0); });
        return Promise.all(extra.map(function (it) {
          return fetch(ROOT + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: it.key, quantity: before[it.key] || 0 })
          }).then(getJSON);
        }));
      })
      .then(function (fixes) {
        setBusy(item, false);
        if (fixes.some(function (f) { return !f.ok; })) {
          setMsg(item, 'Sobrou um par do número ' + size + ' na sacola e não deu para tirar. Atualize a página e remova o que você não quer.', 'error');
          return;
        }
        setMsg(item, addErrorText(result, size, qty), 'error');
      })
      .catch(function () {
        setBusy(item, false);
        setMsg(item, 'Não deu para conferir a sacola. Atualize a página para ver o que ficou nela.', 'error');
      });
  }

  /* A Shopify põe o item recém-adicionado no TOPO da sacola, então o índice de linha que o tema guardou na linha antiga ficou velho:
     usá-lo removeria o item novo. Por isso o índice é refeito a partir de /cart.js antes de o tema remover a linha antiga. */
  function removeOld(item, oldKey, added, size, qty) {
    getCart()
      .then(function (cart) {
        var pos = (cart.items || []).findIndex(function (it) { return it.key === oldKey; });
        if (pos < 0) { recover(oldKey); return; }
        item.setAttribute('data-item-index', String(pos + 1));
        waitForTheme(item, oldKey, added, size, qty);
      })
      .catch(function () {
        setBusy(item, false);
        setMsg(item, 'Adicionamos o ' + size + ', mas não deu para atualizar a sacola. Atualize a página para conferir.', 'error');
      });
  }

  function waitForTheme(item, oldKey, added, size, qty) {
    var finished = false;
    var timer = window.setTimeout(function () {
      if (finished) return;
      finished = true;
      document.removeEventListener('theme:cart:added', onBuilt);
      recover(oldKey);
    }, 12000);

    function onBuilt() {
      if (finished) return;
      finished = true;
      window.clearTimeout(timer);
      document.removeEventListener('theme:cart:added', onBuilt);
      verify(oldKey, added, size, qty);
    }

    document.addEventListener('theme:cart:added', onBuilt);
    /* o tema escuta este evento na própria linha: remove a linha antiga (change.js) e refaz a sacola */
    item.dispatchEvent(new CustomEvent('theme:cart:update', { bubbles: true, detail: { id: oldKey, quantity: 0 } }));
  }

  function verify(oldKey, added, size, qty) {
    getCart()
      .then(function (cart) {
        var stillThere = (cart.items || []).some(function (it) { return it.key === oldKey; });
        var fresh = added && itemByKey(added.key);
        if (stillThere) {
          setMsg(fresh || itemByKey(oldKey), 'Adicionamos o ' + size + ', mas não conseguimos tirar o número anterior. Remova o número que não quer na sacola.', 'error');
          return;
        }
        if (!fresh) return;
        var merged = added && Number(added.quantity) > qty;
        setMsg(fresh, 'Numeração trocada para ' + size + '.' + (merged ? ' Você já tinha esse número na sacola: somamos as quantidades.' : ''));
        var toggle = fresh.querySelector('[data-cro-size-toggle]');
        if (toggle) toggle.focus({ preventScroll: true });
      })
      .catch(function () { /* a sacola já foi refeita pelo tema; sem aviso extra */ });
  }

  /* o tema não respondeu: remove a linha antiga por conta própria e recarrega, para a tela não mentir */
  function recover(oldKey) {
    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: oldKey, quantity: 0 })
    }).then(function () { window.location.reload(); }, function () { window.location.reload(); });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-cro-size-toggle]');
    if (toggle) { event.preventDefault(); togglePanel(toggle, event.detail === 0); return; }

    var opt = event.target.closest('[data-cro-size-opt]');
    if (opt) {
      event.preventDefault();
      var item = opt.closest('[data-cart-item]');
      var size = opt.getAttribute('data-size');
      if (opt.getAttribute('aria-disabled') === 'true') {
        setMsg(item, 'O número ' + size + ' está esgotado.');
        return;
      }
      if (opt.getAttribute('aria-pressed') === 'true') { togglePanel(item.querySelector('[data-cro-size-toggle]')); return; }
      swap(item, opt);
      return;
    }

    if (!event.target.closest('.cro-size__panel')) closePanels(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-cro-size-toggle][aria-expanded="true"]');
    if (!open) return;
    escHandled = true;
    closePanels(null);
    open.focus();
  });

  /* o ESC que fechou o painel não deve fechar também a gaveta */
  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape' && escHandled) { escHandled = false; event.stopPropagation(); }
  }, true);

  /* ------------------------------------------------------------------ barra fixa do /cart (celular) */

  function initBar() {
    var bar = document.querySelector('[data-cro-cart-bar]');
    var wrapper = document.querySelector('[data-cart-checkout-buttons]');
    var aside = document.querySelector('[data-foot-holder]');
    if (!bar || !wrapper || !aside || bar.__croBar) return;
    bar.__croBar = true;

    var btn = bar.querySelector('[data-cro-bar-checkout]');
    var valueEl = bar.querySelector('[data-cro-bar-total]');
    var labelEl = bar.querySelector('[data-cro-bar-label]');
    var mobile = window.matchMedia('(max-width: 1023px)');
    var buttonVisible = true;

    /* parcela mínima de R$ 100 (chamada de 21/10/2026): o resumo só tem a linha de parcelas quando n >= 2, e traz n em data-n;
       o rótulo da barra segue a mesma conta, em vez de prometer 6x fixo */
    function syncTotal() {
      var total = document.querySelector('[data-cro-sum-total]');
      if (total && valueEl) valueEl.textContent = total.textContent.trim();
      if (labelEl) {
        var inst = document.querySelector('[data-cro-sum-inst]');
        var n = inst ? parseInt(inst.getAttribute('data-n'), 10) : 0;
        labelEl.textContent = n >= 2 ? 'Subtotal · até ' + n + 'x sem juros' : 'Subtotal';
      }
    }

    function update() {
      var show = mobile.matches && !aside.classList.contains('hidden') && !buttonVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('cro-cart-bar-on', show);
      if (show) document.body.style.setProperty('--cro-cart-bar-h', bar.offsetHeight + 'px');
    }

    /* o botão de finalizar do resumo é o alvo: o da Yampi, quando ela o coloca ao lado do original, ou o do tema */
    function target() {
      var form = document.querySelector('form[data-cart-form]');
      return form && (form.querySelector('.ymp_elem_mainBtn') || form.querySelector('[name="checkout"]'));
    }

    btn.addEventListener('click', function () {
      var main = target();
      if (main) main.click();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        buttonVisible = entries[entries.length - 1].isIntersecting;
        update();
      }).observe(wrapper);
    }

    document.addEventListener('theme:cart:added', function () { syncTotal(); update(); });
    if (mobile.addEventListener) mobile.addEventListener('change', update);
    syncTotal();
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBar); else initBar();
  document.addEventListener('shopify:section:load', initBar); /* editor de temas: a seção do /cart foi recarregada */
})();
